import { useState } from 'react'
import { ItemBiblioteca } from '@/core/types/graphql'

export const useToolbarElement = () => {
  const [folderToRename, setFolderToRename] = useState<ItemBiblioteca>()
  const [folderToMove, setFolderToMove] = useState<ItemBiblioteca[]>([])
  const [folderToGrant, setFolderToGrant] = useState<ItemBiblioteca>()
  const [folderToAlterarProprietario, setFolderToAlterarProprietario] =
    useState<ItemBiblioteca>()

  return {
    folderToRename,
    setFolderToRename,
    folderToMove,
    setFolderToMove,
    folderToGrant,
    setFolderToGrant,
    folderToAlterarProprietario,
    setFolderToAlterarProprietario
  }
}
